<div
  class="sp-dialog__min-width"
  style="max-width: 900px">
  <div class="sp-width__full sp-row__end">
    <button
      (click)="onCloseClick()"
      mat-icon-button
      class="sp-icon__button sp-icon__button-accent">
      <mat-icon> clear </mat-icon>
    </button>
  </div>

  <div class="sp-padding__vert-x2">
    <mat-expansion-panel
      *ngFor="let call of vop_calls"
      class="sp-margin__bottom-x2">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <h2 class="sp-color__accent">
            {{ getVopRequestMostSimilarCallLabel(call.type) | translate }}
            ({{ call.created_at | date : 'short' }})
          </h2>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div>
        <div *ngIf="call.vop_call.request">
          <h3 class="sp-margin__top-x2">Request</h3>
          <pre style="overflow-x: scroll"> {{ call.vop_call.request | json }} </pre>
        </div>

        <div *ngIf="call.vop_call.response">
          <h3 class="sp-margin__top-x2">Response</h3>
          <pre style="overflow-x: scroll"> {{ call.vop_call.response | json }} </pre>
        </div>

        <div *ngIf="call.vop_call.error">
          <h3 class="sp-margin__top-x2">Error</h3>
          <pre style="overflow-x: scroll"> {{ call.vop_call.error | json }} </pre>
        </div>
      </div>
    </mat-expansion-panel>
  </div>
</div>
